import { useMutation } from "@apollo/client";

import { STAND_COMMENT_UPDATE } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";


const useMutationStandCommentUpdate = ({
    showSuccessNotification = true,
    showErrorNotification = true,
    onCompleted = () => {},
    onError = () => {},
} = {}) => {
    const [ _setStandCommentUpdate, { loading } ] = useMutation(STAND_COMMENT_UPDATE, {
        update(cache, { data }) {
            const payload = data?.commentUpdate;
            if (showSuccessNotification && payload?.label) {
                successNotification({
                    title: payload.label,
                    description: payload.message,
                });
            }
            onCompleted(payload);
        },
        onError(error) {
            if (showErrorNotification) {
                errorNotification(error);
            }
            onError(error);
        },
    });

    return {
        _setStandCommentUpdate,
        loadingMutationStandCommentUpdate: loading,
    };
};

export default useMutationStandCommentUpdate;
